module.exports = __webpack_public_path__ + "static/img/banner.e9fe185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 1